/* eslint-disable import/prefer-default-export */

// Garde-fou de saisie, pas une validation d'adresse : le serveur reste
// l'autorité. Le trim tolère l'espace collé depuis un client mail.
export function isEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
